export default "__VITE_ASSET__Dlhb$ZPE__"